import * as types from '../constants/outstandingOrderConstants';
import appConstants from '../appConstants'
import moment from 'moment';
const initialState = {
  bmList: [],
  lmtModifyFlag: false,
  ocoOrderData: "",
  otoOrderData:''
};

const getOrdData = (ordDetails) => {
  try {
    if (ordDetails) {
      if (ordDetails.OT === appConstants.STOP_ORD_TYPE) {
        ordDetails.dealType = "Stop " + (parseInt(ordDetails.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL")
      } else {
        ordDetails.dealType = (parseInt(ordDetails.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL")
      }
    }
    return ordDetails;
  } catch (e) {
    console.log(" ec" + e);
  }
}

const getOTOOrdData = (data) => {
  try {
    let ordDetails = [];
    data.length !== 0 && data.map(ord => {
      if (ord.OT === appConstants.STOP_ORD_TYPE) {
        ord.dealType = "Stop " + (parseInt(ord.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL")
      } else {
        ord.dealType = (parseInt(ord.DT) === appConstants.TRADER_BUY ? "BUY" : "SELL")
      }
      ordDetails.push(ord)
    })
    return ordDetails;
  } catch (e) {
    console.log("Exception: " + e);
  }
}

export default function (state = initialState, action) {
  switch (action.type) {
    case types.LOAD_OUTSTANDING_ORDER:
      return {
        ...state,
      };
    case types.LOAD_OUTSTANDING_ORDER_SUCCESS:

      return {
        ...state,
      };
    case types.LOAD_OUTSTANDING_ORDER_FAILURE:
      return {
        ...state,
      };
    case types.GET_ALL_BM:
      return {
        ...state,
      };
    case types.GET_ALL_BM_SUCCESS:
      return {
        ...state,
        bmList: action.result.data
      };
    case types.GET_ALL_BM_FAILURE:
      return {
        ...state,
      };
    case types.LOAD_LMTMODIFYPOPUP_FLAG:
      localStorage.setItem('lmtModifyFlag', action.flag);
      return {
        ...state,
        lmtModifyFlag: action.flag
      };
    case types.GET_OCO_ORD_DET:
      return {
        ...state,
      };
    case types.GET_OCO_ORD_DET_SUCCESS:
      return {
        ...state,
        ocoOrderData: getOrdData(action.result.data)
      };
    case types.GET_OCO_ORD_DET_FAILURE:
      return {
        ...state,
      };
      case types.GET_OTO_ORD_DET:      
        return {
          ...state,
        };
      case types.GET_OTO_ORD_DET_SUCCESS:
        return {
          ...state,
          otoOrderData: getOTOOrdData(action.result.data),
          otoDataRandomNo: Math.floor((Math.random() * 100) + 1)
        };
      case types.GET_OTO_ORD_DET_FAILURE:

        return {
          ...state,
        };
    default:
      return state;
  }
}
